import { render, staticRenderFns } from "./PopUpForm.vue?vue&type=template&id=8246f9f4&scoped=true"
import script from "./PopUpForm.vue?vue&type=script&lang=js"
export * from "./PopUpForm.vue?vue&type=script&lang=js"
import style0 from "./PopUpForm.vue?vue&type=style&index=0&id=8246f9f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8246f9f4",
  null
  
)

export default component.exports